import { styled } from 'styled-components'

export const ErrorModalWrapper = styled.div`
  align-items: flex-start;
`

export const ErrorModalTitle = styled.h2`
  font-family: ${props => props.theme.font.secondary};
  font-size: 48px;
  color: ${props => props.theme.color.black};
  margin-bottom: 8px;
`

export const ErrorModalDescription = styled.h3`
  font-size: 22px;
  color: ${props => props.theme.color.black};
  margin-bottom: 32px;
  opacity: 0.5;
`
